// extracted by mini-css-extract-plugin
export default {"testSearch":"_1jcuRJjs5cMpXDALg44mXa","text-map":"_2RkizN5Q-M8U_xjGpGlUcm","col-lg-8":"SPVHjVviKK4DDImPydTck","col-lg-4":"_3a-C_BWU7eaal3hTUBXRYQ","tabs":"_3i-2Vv-iTTAxvcdjXIKKI_"};